import { DeliveryAddressSelector } from './DeliveryAddress/DeliveryAddressSelector';
import { HEADER_TEST_IDENTIFIER, HeaderProps } from './Header';
import { HeaderBottom } from './HeaderBottom/HeaderBottom';
import { B2bLogo } from './HeaderTop/Logo/B2bLogo';
import Overlay from 'components/Basic/Overlay/Overlay';
import { useCurrentCustomerData } from 'connectors/customer/CurrentCustomer';
import { useMediaMin } from 'hooks/ui/useMediaMin';
import useTranslation from 'next-translate/useTranslation';
import { memo } from 'react';

export const B2bHeader = memo<HeaderProps>(({ simple }) => {
    const currentCustomerData = useCurrentCustomerData();
    const { t } = useTranslation();
    const isDesktop = useMediaMin('vl');

    return (
        <div className="vl:menu-gradient relative z-menu mb-5 bg-primary" data-testid={HEADER_TEST_IDENTIFIER}>
            <div className="flex w-full flex-wrap justify-between vl:px-5 xl:mx-auto xl:w-layout">
                <div className="flex h-11 flex-1 items-center justify-between vl:h-16 vl:shrink-0 vl:grow vl:basis-full">
                    <B2bLogo linkText={t('Go to homepage')} />
                    {!simple && (
                        <>
                            <div className="peer/selector w-fit-content hidden vl:block">
                                {currentCustomerData && isDesktop && (
                                    <DeliveryAddressSelector currentCustomerUser={currentCustomerData} />
                                )}
                            </div>
                            <Overlay withWrapper={false} className="hidden peer-focus-within/selector:vl:block" />
                        </>
                    )}
                </div>
                {!simple && currentCustomerData && <HeaderBottom currentCustomerUser={currentCustomerData} />}
            </div>
        </div>
    );
});

B2bHeader.displayName = 'B2bHeader';
